import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import SocialShareApps from './SocialShareApps';
import socialShareTwStyles from './socialShare-tw-styles';
import { Button } from '../../Generic/Button';
import path from '../../../assets/images/svgImages.svg';
import i18nMessages from '../../../constants/messages/pt-BR';

const spritePath = typeof path === 'string' ? path : path?.src || '';

export class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDialogOpen: false,
      isNavDialog: false,
      appSelected: '',
      isMobile: false,
      socialShareData: [
        { appType: i18nMessages.facebook },
        { appType: i18nMessages.pinterest },
        { appType: i18nMessages.twitter },
        { appType: i18nMessages.whatsApp },
      ],
    };
    this.closeButtonRef = React.createRef();
    this.previousFocusRef = null;
  }

  componentDidMount() {
    window.addEventListener(i18nMessages.resize, this.handleWindowChange);
    this.handleWindowChange();
    window.addEventListener(i18nMessages.scroll, this.scrollHandler);
    this.scrollHandler();
  }
  componentWillUnmount() {
    window.removeEventListener(i18nMessages.resize, this.handleWindowChange);
    window.removeEventListener(i18nMessages.scroll, this.scrollHandler);
  }
  scrollHandler = () => {
    const { template } = this.props;
    const { isMobile } = this.state;
    const socialDiv = document.getElementsByClassName(
      `socialShareDivClose${template}`
    );
    const socialShareModalDiv = document.getElementsByClassName(
      `socialShareModal${template}`
    );
    let productMobile = isMobile && template === i18nMessages.product;
    if (template === i18nMessages.productSticky || productMobile) {
      if (
        document.body.scrollTop > 50 ||
        document.documentElement.scrollTop > 50
      ) {
        console.log('inside if..')
        if (socialDiv[0]) {
          socialDiv[0].classList.add(i18nMessages.scrollSticky);
        }
        if (socialShareModalDiv[0]) {
          socialShareModalDiv[0].classList.add(
            i18nMessages.socialShareModalStyle
          );
        }
      } else {
        console.log('inside else')
        if (socialDiv[0]) {
          socialDiv[0].classList.remove(i18nMessages.scrollSticky);
        }
        if (socialShareModalDiv[0]) {
          socialShareModalDiv[0].classList.remove(
            i18nMessages.socialShareModalStyle
          );
        }
      }
    }
  };
  handleWindowChange = () => {
    const isMobile = window.innerWidth < 767;
    this.setState({
      isMobile: isMobile,
    });
  };
  toggleDialog = () => {
    const { isDialogOpen } = this.state;
    
    // Store the currently focused element before opening modal
    if (!isDialogOpen) {
      this.previousFocusRef = document.activeElement;
    }
    
    this.setState(
      prevState => ({
        isDialogOpen: !prevState.isDialogOpen,
      }),
      () => {
        const body = document.getElementsByTagName(i18nMessages.body);
        this.scrollHandler();
        if (!isDialogOpen) {
          setTimeout(() => {
            if (this.closeButtonRef?.current) {
              this.closeButtonRef?.current?.focus();
            }
          }, 100);
        }
      }
    );
  };

  closeNavDialog = () => {
    this.setState({ isNavDialog: false });
    this.setState({ isDialogOpen: false }, () => {
      const body = document.getElementsByTagName(i18nMessages.body);
      this.scrollHandler();
      if (body[0]) {
        body[0].classList.remove(i18nMessages.socialDivCloseStyle);
      }
      // Restore focus to the element that opened the modal
      if (this.previousFocusRef && typeof this.previousFocusRef.focus === 'function') {
        this.previousFocusRef.focus();
      }
    });
  };

  setSelectedApp = (appType, navState, dialogState) => {
    this.setState({
      appSelected: appType,
      isNavDialog: navState,
      isDialogOpen: dialogState,
    });
  };
  render() {
    const {
      isDialogOpen,
      isNavDialog,
      appSelected,
      isMobile,
      isCard,
      socialShareData,
    } = this.state;
    const {
      shareIcon,
      shareImage,
      shareDescription,
      locale,
      template,
      productName
    } = this.props;
    return (
      <div
        id={!isCard ? i18nMessages.socialconnectdiv : ''}
        className={classNames(
          template === i18nMessages.article
            ? socialShareTwStyles.articlePageStyle
            : ''
        )}
      >
        <div>
          <Button
            className={classNames(
              'shareicon-btn mb-2 no-outline',
              socialShareTwStyles.button
            )}
            aria-label={productName ? `Compartilhar ${productName} nas redes sociais` : (i18nMessages.shareProductAriaLabel || 'Compartilhar nas redes sociais')}
            aria-expanded={isDialogOpen}
            handler={this.toggleDialog}
            type="button"
            tabIndex={0}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.toggleDialog();
              }
            }}
          >
            {template === i18nMessages.article ? (
              <svg
                className={classNames(
                  'share-icon block',
                  socialShareTwStyles.iconStyles,
                  'w-40x h-40'
                )}
              >
                <use xlinkHref={`${spritePath}#${shareIcon}`} />
              </svg>
            ) : (
              <svg
                className={classNames(
                  'share-icon block',
                  socialShareTwStyles.iconStyles,
                  'w-18 h-18'
                )}
              >
                <use xlinkHref={`${spritePath}#${shareIcon}`} />
              </svg>
            )}
          </Button>
        </div>

        <div
          className={classNames(
            socialShareTwStyles.socialDialogWrapper,
            `socialShareModal${template}`,
            isDialogOpen ? 'socialPopUpOPen' : 'socialPopUpClose'
          )}
          id={i18nMessages.socialShareModal}
          role="dialog"
          aria-modal="true"
          aria-label="Compartilhar nas redes sociais"
          tabIndex={-1}
          ref={el => { this.dialogRef = el; }}
          onKeyDown={e => {
            // Handle Escape key to close modal
            if (e.key === 'Escape') {
              e.preventDefault();
              this.closeNavDialog();
              return;
            }
            
            // Handle Tab key for focus trap
            if (e.key === 'Tab') {
              const focusableEls = this.dialogRef && this.dialogRef.querySelectorAll(
                'button:not([disabled]), [href]:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled])'
              );
              if (!focusableEls || focusableEls.length === 0) return;
              const first = focusableEls[0];
              const last = focusableEls[focusableEls.length - 1];
              if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
              }
              if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
              }
            }
          }}
        >
          <div className={classNames(socialShareTwStyles.dialogWrapper)}>
           
            <SocialShareApps
              socialShareData={socialShareData}
              isNavDialog={isNavDialog}
              setSelectedApp={this.setSelectedApp}
              appSelected={appSelected}
              isMobile={isMobile}
              isCard={isCard}
              closeNavDialog={this.closeNavDialog}
              shareImage={shareImage}
              shareDescription={shareDescription}
              locale={locale}
            />
            <Button
              className={'absolute sm:top-10px md:top-[-15px] sm:right-[-15px] md:right-10'}
              aria-label='Fechar modal'
              ref={this.closeButtonRef}
              onClick={this.closeNavDialog}
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  this.closeNavDialog();
                }
              }}
            >
              <span className={'closespan'}>×</span>
            </Button>
          </div>
        </div>
        <div
          role="presentation"
          id={i18nMessages.socialShareDivClose}
          className={classNames(
            'relative h-full w-full',
            `socialShareDivClose${template}`
          )}
          onClick={this.closeNavDialog}
        />
      </div>
    );
  }
}
Index.propTypes = {
  shareImage: PropTypes.string,
  shareDescription: PropTypes.string,
  locale: PropTypes.string,
  template: PropTypes.string,
  shareIcon: PropTypes.string,
};

Index.defaultProps = {
  shareIcon: '',
  shareImage: '',
  shareDescription: '',
  locale: 'pt-BR',
  template: '',
};
export default Index;
